module.exports = __webpack_public_path__ + "static/media/clostR.3fdd3f5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clostR.png
// module id = 649
// module chunks = 0 1